import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { UserService } from './services/user.service';
import { RedirectOnLoginService } from './services/redirect-on-login.service';

@Injectable()
export class LoginRedirectGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router,
    private redirectOnLoginService: RedirectOnLoginService,
  ) {}
  //When user attempts to access a URL without logging in, LoginRedirectGuard is first invoked.
  // At this point, we store current RouterStateSnapshot, which can be later used for redirection after user logins successfully.
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    // Always allow access to the route (return true) regardless of the user's authentication status
    // The actual authentication check will be done by another guard or your AuthInterceptor.
    return true;
  }
}
